import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import ContactPerson from "./ContactPerson";
import Notes from "./Notes";
import PaymentInfo from "./Payments";

import Add from "../../users/super-admin/Add";
import UsersList from "../../users/super-admin/List";

const GeneralInfo = ({ companyId }) => {
	return (
		<Grid container spacing={5}>
			<Grid
				size={{
					xs: 12,
					md: 12,
					lg: 5,
				}}
			>
				<Box>
					<ContactPerson companyId={companyId} />
				</Box>
				<Box sx={{ mt: 4 }}>
					<Notes companyId={companyId} />
				</Box>
			</Grid>
			<Grid
				size={{
					xs: 12,
					md: 12,
					lg: 7,
				}}
			>
				<Box>
					<PaymentInfo companyId={companyId} />
				</Box>
				<Box sx={{ position: "relative" }}>
					<Box
						sx={{
							position: "absolute",
							top: "13px",
							left: 0,
							zIndex: 120,
						}}
					>
						<Add />
					</Box>
					<UsersList companyId={companyId} />
				</Box>
			</Grid>
		</Grid>
	);
};

export default GeneralInfo;
